module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7KSKf"))).then(() => parcelRequire('1iHdE'));